var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3675_14730",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0007 8.99984H4.99818C4.44566 8.99984 3.99776 9.44775 3.99776 10.0003C3.99776 10.5528 4.44566 11.0007 4.99818 11.0007H11.0007C11.5532 11.0007 12.0011 10.5528 12.0011 10.0003C12.0011 9.44775 11.5532 8.99984 11.0007 8.99984ZM15.0023 4.99818H4.99818C4.44566 4.99818 3.99776 5.44608 3.99776 5.99859C3.99776 6.55111 4.44566 6.99901 4.99818 6.99901H15.0023C15.5549 6.99901 16.0028 6.55111 16.0028 5.99859C16.0028 5.44608 15.5549 4.99818 15.0023 4.99818ZM17.0032 -0.00390625H2.99734C1.3398 -0.00390625 -0.00390625 1.3398 -0.00390625 2.99734V13.0015C-0.00390625 14.6591 1.3398 16.0028 2.99734 16.0028H14.5922L18.2937 19.7143C18.4825 19.9016 18.7381 20.006 19.004 20.0044C19.1352 20.0078 19.2654 19.9804 19.3842 19.9244C19.7578 19.7709 20.0024 19.4079 20.0044 19.004V2.99734C20.0044 1.3398 18.6607 -0.00390625 17.0032 -0.00390625ZM18.0036 16.593L15.7126 14.292C15.5238 14.1048 15.2683 14.0004 15.0023 14.0019H2.99734C2.44483 14.0019 1.99693 13.554 1.99693 13.0015V2.99734C1.99693 2.44483 2.44483 1.99693 2.99734 1.99693H17.0032C17.5557 1.99693 18.0036 2.44483 18.0036 2.99734V16.593Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3675_14730)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#828282"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.06912d60ebbdf592e267ce23ffc245a5.svg";
export { ForwardRef as ReactComponent };